import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const config = {
    apiKey: "AIzaSyBCeYR6rJVrBm0Ig9aSqAyh9ncwNFzwmHM",
    authDomain: "grabity-defa4.firebaseapp.com",
    projectId: "grabity-defa4",
    storageBucket: "grabity-defa4.appspot.com",
    messagingSenderId: "528575940018",
    appId: "1:528575940018:web:bd23d029ecf25836c350ab",
    measurementId: "G-JK0Y71HYV5",
};

export const app = initializeApp(config);
export const db = getFirestore(app);